import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type DelayedNotificationValues = ReturnType<typeof useDelayedNotificationValues>

/**
 * That hook grabs delayedNotification values from the domains, than filter some of them out and
 * does some type conversion where required
 */
export function useDelayedNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return useMemo(() => {
    const { toleranceMins, includeMessageUnsubscriptionInstructions, ...rest } =
      notificationSettings['delayedSettings']

    return {
      ...rest,
      toleranceMins: toleranceMins.toString(),
      proximityThresholdMins: '10',
      windowOfCommitmentToleranceMins: '30',
      notificationCutoffMins: 0,
      windowOfCommitmentSnapToMins: 0,
      alwaysNotifyAfterCutoff: false,
      // includeMessageUnsubscriptionInstructions should alwayes be true for phone
      includeMessageUnsubscriptionInstructionsPhone: true,
      // includeMessageUnsubscriptionInstructions should be based on the value from the domain for email
      includeMessageUnsubscriptionInstructionsEmail: includeMessageUnsubscriptionInstructions,
    }
  }, [notificationSettings])
}
